import React from 'react'
import { Switch } from './ui'
import { useI18n } from '../i18n'

// Per-script eligibility and tariff only: not a send, a payment or an auto-mode toggle.
export default function PaidSextingFields({ value, onChange, disabled = false }) {
  const { t } = useI18n()
  const current = value || { enabled: false, price: '' }
  return <fieldset disabled={disabled} style={{ minWidth: 0, margin: '12px 0', padding: '12px', border: '1px solid var(--border-color, #555)', borderRadius: '12px' }}>
    <legend>{t('paidScript.title')}</legend>
    <Switch checked={current.enabled} onChange={enabled => onChange?.({ ...current, enabled })} label={t('paidScript.allowScript')} ariaLabel={t('paidScript.allowScript')} />
    <p className="model-edit-hint">{t('paidScript.scriptHint')}</p>
    {current.enabled ? <label style={{ display: 'grid', gap: '6px', minWidth: 0 }}>
      <span>{t('paidScript.price')}</span>
      <input className="model-edit-input" type="text" inputMode="decimal" required value={current.price} onChange={event => onChange?.({ ...current, price: event.target.value })} placeholder="129.00" style={{ width: '100%', boxSizing: 'border-box' }} />
    </label> : null}
    <small>{t('paidScript.terms')}</small>
  </fieldset>
}
